module.exports = __webpack_public_path__ + "assets/successSparkleA-396f3c.svg";